import React, { Component } from "react";
import { connect } from "react-redux";
import {
	getIntegrationSettings,
	setIntegrationSettings,
} from "../actions/tenantActions";
import AsyncSwitch from "./AsyncSwitch";
import AdminOnlyWarning from "./Settings/AdminOnlyWarning";
import { getDisabledFeatureCodeMessage } from "../utilities/utilities";

class IntegrationSettings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canSubmit: false,
			integrationSettingsLoading: true,
		};
		this.getDisabledHoverText = this.getDisabledHoverText.bind(this);
	}

	static getDerivedStateFromProps(props, state) {
		if (
			state.integrationSettingsLoading &&
			!props.integrationSettingsLoading
		) {
			const newState = {
				integrationSettingsLoading: false,
			};
			return newState;
		} else {
			return null;
		}
	}

	componentDidMount() {
		this._isMounted = true;
		this.props.getIntegrationSettings();
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	getDisabledHoverText = (featureCode) => {
		if (featureCode === "literaDocumentCompareEnabled") {
			return getDisabledFeatureCodeMessage(featureCode);
		}
		return null;
	};

	render() {
		return (
			<div style={{ width: 600, paddingTop: 20, paddingLeft: 15 }}>
				{this.state.integrationSettingsLoading ? null : (
					<div>
						<AdminOnlyWarning
							userCanEditSettings={
								this.props.canEditIntegrationSettings
							}
						/>
						<AsyncSwitch
							label={"Clio Manage"}
							switchValue={
								this.props.clioIntegrationSettingStatus
							}
							disabled={!this.props.canEditIntegrationSettings}
							updateSetting={(newValue) => {
								return this.props.setIntegrationSettings({
									featureCode: "clioIntegration",
									featureValue: newValue,
								});
							}}
						/>
						<AsyncSwitch
							label={"Litera Compare Desktop"}
							switchValue={
								this.props
									.literaDocumentCompareVisibleSettingStatus
							}
							disabled={
								!this.props.canEditIntegrationSettings ||
								!this.props.literaDocumentCompareEnabled
							}
							disabledHoverText={
								!this.props.canEditIntegrationSettings ||
								!this.props.literaDocumentCompareEnabled
									? this.getDisabledHoverText(
											"literaDocumentCompareEnabled"
										)
									: ""
							}
							updateSetting={(newValue) => {
								return this.props.setIntegrationSettings({
									featureCode: "literaDocumentCompareVisible",
									featureValue: newValue,
								});
							}}
						/>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	integrationSettingsLoading: state.tenant.integrationSettingsLoading,
	canEditIntegrationSettings: state.user.userRights
		? state.user.userRights.UPDATE_INTEGRATIONS
		: false,
	clioIntegrationSettingStatus: state.tenant.tenantFeatures.clioIntegration,
	literaDocumentCompareVisibleSettingStatus:
		state.tenant.tenantFeatures.literaDocumentCompareVisible,
	literaDocumentCompareEnabled:
		state.tenant.tenantFeatures.literaDocumentCompareEnabled,
});
export default connect(mapStateToProps, {
	getIntegrationSettings,
	setIntegrationSettings,
})(IntegrationSettings);
